<template>
  <div>
    <h1>Lista de Clientes</h1>

    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'clientes_create' }"
            v-if="$can('cliente:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table
        striped
        hover
        :items="clientes"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(nome)="{ item }">
          {{ item.nome }}
        </template>
        <template #cell(endereco)="{ item }">
          <CellEndereco
            :endereco="
              item.pessoa_juridica_id && item.pessoa_juridica
                ? item.pessoa_juridica.endereco
                : item.pessoa_fisica.endereco
            "
          />
        </template>
        <template #cell(contatos)="{ item }">
          <CellContatos
            :contatos="
              item.pessoa_juridica_id
                ? item.pessoa_juridica.contatos
                : item.pessoa_fisica.contatos
            "
          />
        </template>

        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('cliente:edit')"
            :view_delete="$can('cliente:delete')"
            edit_to="clientes_edit"
            @delete="deleteItem"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  components: { Actions },
  mixins: [mixins],

  computed: {
    ...mapState("clientes", ["clientes", "pagination"]),
    fields() {
      return [
        {
          key: "id",
          label: "COD",
          class: "col-1",
          sortable: true,
        },
        {
          key: "nome",
          label: "nome",
          sortable: true,
        },
        { key: "endereco", label: "Endereço" },
        { key: "contatos", label: "Contatos" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("clientes", ["ActionGetAll", "ActionDelete"]),
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
  mouted() {},
};
</script>

<style></style>
